import { apiClient } from "./apiClient";

export const decreaseReasonService = {
  /**
   * Create a new decrease reason
   */
  createDecreaseReason: async (name: string) => {
    const response = await apiClient.post("/decrease-reasons/", {
      name,
      english_name: name, // Use same name for English by default
    });
    return response.data;
  },
};
